import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconToque: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="toque, chefs-cap, cook"><path d="M17.1967 4.99927L17.1994 5.0039C19.8684 5.10856 22 7.30535 22 10C22 12.0503 20.7659 13.8124 19 14.584V16.5H5V14.584C3.2341 13.8124 2 12.0503 2 10C2 7.30541 4.13152 5.10867 6.80043 5.00391C7.8373 3.20835 9.77754 2 12 2C14.2221 2 16.1608 3.20848 17.1967 4.99927Z" fill="currentColor"/><path d="M5 18V20.25C5 21.2165 5.7835 22 6.75 22H17.25C18.2165 22 19 21.2165 19 20.25V18H5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconToque;
